import { setUser } from "@sentry/vue";

// user?: { id: number | string; email:string; name:string }
export function setSentryUser(user) {
  if (!user) {
    setUser(null);
    return;
  }

  const { id, email, name } = user;

  setUser({
    id: id?.toString(),
    email: email ?? undefined,
    username: name ?? undefined,
  });
}
